<nb-select fullWidth
           [placeholder]="placeholder()"
           [(selected)]="selected"
           [disabled]="isDisabled">
  @if (showEmptyOption()) {
    <nb-option [value]="emptyOption">Keine</nb-option>
  }
  @for (v of values(); track v) {
    <nb-option [value]="v">{{ v | sensorUnit }}</nb-option>
  }
</nb-select>
